var map = {
	"./automatic.svg": "2144",
	"./bw1mapper.svg": "6bd4",
	"./bw1player.svg": "f5f1",
	"./bw1studio.svg": "ad51",
	"./bwclockserver.svg": "6a5d",
	"./urleditor.svg": "8713"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "414e";